/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import { useRef, useEffect } from 'react';
import { uid } from 'uid';

function useTilt(active) {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current || !active) {
      return;
    }

    const state = {
      rect: undefined,
      mouseX: undefined,
      mouseY: undefined,
    };

    const el = ref.current;

    const handleMouseMove = (e) => {
      if (!el) {
        return;
      }
      if (!state.rect) {
        state.rect = el.getBoundingClientRect();
      }
      state.mouseX = e.clientX;
      state.mouseY = e.clientY;
      const px = (state.mouseX - state.rect.left) / state.rect.width;
      const py = (state.mouseY - state.rect.top) / state.rect.height;

      el.style.setProperty('--px', px);
      el.style.setProperty('--py', py);
    };

    el.addEventListener('mousemove', handleMouseMove);

    const returMe = () => {
      el.removeEventListener('mousemove', handleMouseMove);
    };

    return returMe;
  }, [active]);

  return ref;
}

const SlideShow = ({ slide, offset }) => {
  const active = offset === 0 ? true : null;
  const ref = useTilt(active);
  return (
    <div
      ref={ref}
      className="slide"
      data-active={active}
      style={{
        '--offset': offset,
        '--dir': offset === 0 ? 0 : (offset > 0) ? 1 : -1,
      }}
    >
      <div
        className="slideBackground"
        style={{
          backgroundImage: `url('${slide.image}')`,
        }}
      />
      <div
        className="slideContent"
        style={{
          backgroundImage: `url('${slide.image}')`,
        }}
      >
        <div className="slideContentInner">
          <h2 className="slideTitle">{slide.title}</h2>
          <h3 className="slideSubtitle">{slide.subtitle}</h3>
          <p className="slideDescription">{slide.description}</p>
          <ul className="flex justify-center flex-wrap">
            {slide.technologies.map((technology) => (
              <li className="font-semibold uppercase px-3 py-1 m-3 dark:bg-slate-50 dark:text-slate-900 text-slate-50 bg-slate-900 rounded-md" key={uid()}>{technology}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

SlideShow.propTypes = {
  offset: PropTypes.number.isRequired,
  slide: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    technologies: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
};

export default SlideShow;
